
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import growimage from '../../../images/footerLinksImages/enterpreneur/growbusinness.jpg'
import onlinemarketingimage from '../../../images/footerLinksImages/enterpreneur/onlinemarketing.png'
function OnlineMarketer() {

    



const keywords = [
  { title: "Digital Trading Platforms", summary: "Learn how to use cutting-edge digital platforms for online trading in stocks, crypto, and forex markets." },
  { title: "Automated Trading Systems", summary: "Explore the use of algorithms and AI in automated trading to maximize profits and reduce manual interventions." },
  { title: "Blockchain and Cryptocurrency", summary: "Understand how blockchain technology powers cryptocurrency trading and how to leverage it for online marketing." },
  { title: "Artificial Intelligence in Trading", summary: "Discover how AI is revolutionizing trading strategies and enhancing decision-making for traders." },
  { title: "Data Analytics for Traders", summary: "Use data analytics tools to analyze market trends and make informed trading decisions with higher accuracy." },
  { title: "SEO for Trading Websites", summary: "Learn SEO strategies tailored for trading websites to rank higher on search engines and attract targeted traffic." },
  { title: "Social Media Marketing for Trading", summary: "Promote trading strategies and tips on social media platforms to engage a global audience and build a community." },
  { title: "Affiliate Marketing for Trading Tools", summary: "Earn passive income by promoting trading tools and platforms through affiliate marketing." },
  { title: "Mobile Trading Apps", summary: "Master the use of mobile apps for trading on the go, staying connected to the market anytime, anywhere." },
  { title: "PPC Campaigns for Trading Services", summary: "Set up pay-per-click advertising campaigns to promote trading services and attract more leads and customers." }
];

    return (<>
        <Header />
        
        <BannerFooter
            title="Online Marketer"
            text="Are you passionate about leveraging digital platforms to drive engagement in the fields of trading and web technology? We’re looking for an innovative online marketer to design and execute impactful campaigns that connect audiences with advanced trading strategies and modern web solutions. Your role will involve crafting compelling content, managing SEO and PPC campaigns, and utilizing analytics to optimize performance. Collaborate with experts to bridge the gap between cutting-edge technology and financial markets, ensuring our brand reaches the right audience. If you’re ready to lead in the digital space and inspire growth, join us today!"
            imageone={onlinemarketingimage}
            imagetwo={onlinemarketingimage}
        />
         <div className="contianer-fluid py-4 my-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                            <img src={growimage} alt="" className="object-fit-cover h-100 w-100"/>
                    </div>
                </div>
            </div>
         </div>

         <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Online Marketing for Trading & Technology</h2>
    <div className="accordion" id="marketingAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#marketingAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default OnlineMarketer